import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "style-wrapper"
}
const _hoisted_2 = { class: "bedge" }
const _hoisted_3 = {
  key: 0,
  class: "style-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_ctx.stylesApplied)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_tooltip, {
          placement: "top",
          content: _ctx.styleTooltip,
          "show-after": 10
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "lock" }, null, -1)),
              (_ctx.showStyleName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.styleName), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }, 8, ["content"])
      ]))
    : _createCommentVNode("", true)
}